import { reactive, ref, watch } from 'vue';
export const useFormItemRender = props => {
  const formData = ref();
  const fieldName = ref('');
  const fieldOptions = reactive({});
  watch(() => props.renderParams, val => {
    const {
      field,
      data,
      disabled = false,
      readonly = false
    } = val || {};
    formData.value = data;
    fieldName.value = field;
    Object.assign(fieldOptions, {
      disabled,
      readonly
    });
  }, {
    immediate: true,
    deep: true
  });
  watch(() => props.renderOpts, val => {
    const {
      props = {}
    } = val || {};
    Object.assign(fieldOptions, props);
  }, {
    immediate: true,
    deep: true
  });
  return {
    formData,
    fieldName,
    fieldOptions
  };
};